import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./App.css";

import Navbar from "./components/Navbar";
import SessionManager from "./components/SessionManager";

const App: React.FC = () => {
  return (
    <Router>
      <SessionManager />
      <div className='main'>
        <Navbar />
      </div>
    </Router>
  );
};

export default App;
